// Device region / country detection for Timelining workspace creation

/**
 * Detects the device country as an ISO 3166-1 alpha-2 code from the browser / runtime locale,
 * or returns 'GLOBAL' if undetermined or invalid.
 */
export function detectDeviceCountry(localeOverride?: string): string {
  let locale = localeOverride
  if (!locale && typeof navigator !== 'undefined') {
    if (Array.isArray(navigator.languages) && navigator.languages.length > 0 && typeof navigator.languages[0] === 'string') {
      locale = navigator.languages[0]
    } else if (navigator.language) {
      locale = navigator.language
    }
  }
  if (!locale && typeof Intl !== 'undefined') {
    locale = new Intl.NumberFormat().resolvedOptions().locale
  }

  if (!locale || typeof locale !== 'string') {
    return 'GLOBAL'
  }

  const clean = locale.trim()

  // Try standard Intl.Locale if available
  if (typeof Intl !== 'undefined' && typeof Intl.Locale === 'function') {
    try {
      const parsed = new Intl.Locale(clean)
      if (parsed.region && /^[A-Za-z]{2}$/.test(parsed.region)) {
        return parsed.region.toUpperCase()
      }
    } catch {
      // Fall through to regex / split parsing
    }
  }

  const parts = clean.replace(/_/g, '-').split('-')
  if (parts.length >= 2) {
    const candidate = parts[parts.length - 1].toUpperCase()
    if (/^[A-Z]{2}$/.test(candidate)) {
      return candidate
    }
  }

  return 'GLOBAL'
}
